import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Transition } from 'react-transition-group';
import styled from 'styled-components';
import { Link, Portal } from '@miro-site/core';
import useFullscreenModal from '../../../hooks/useFullscreenModal';
import Accordion from './../../accordion/Accordion';
import Item from './../../accordion/Item';
import Popup from './../../popup/Popup';
import { jsx as _jsx } from "react/jsx-runtime";
var transitionStyles = {
  entering: {
    opacity: 1,
    visibility: 'visible'
  },
  entered: {
    opacity: 1,
    visibility: 'visible'
  },
  exiting: {
    opacity: 0,
    visibility: 'hidden'
  },
  exited: {
    opacity: 0,
    visibility: 'hidden'
  }
};
var CategoryNavMobile = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var rootGroups = _ref.rootGroups,
      _ref$isVisible = _ref.isVisible,
      isVisible = _ref$isVisible === void 0 ? false : _ref$isVisible,
      onMobilePopupClose = _ref.onMobilePopupClose,
      onCategoryOpen = _ref.onCategoryOpen;
  useFullscreenModal(isVisible);
  return /*#__PURE__*/_jsx(Transition, {
    "in": isVisible,
    timeout: 2500,
    children: function children(state) {
      return /*#__PURE__*/_jsx(Portal, {
        children: /*#__PURE__*/_jsx(Popup, {
          $styles: _objectSpread({
            position: 'fixed',
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            height: '100%',
            overflow: 'auto',
            zIndex: 710,
            textAlign: 'center',
            transition: "opacity 250ms ease-in-out, visibility 250ms ease-in-out",
            visibility: 'hidden',
            opacity: 0
          }, transitionStyles[state]),
          onCloseClick: function onCloseClick() {
            if (onMobilePopupClose) {
              onMobilePopupClose();
            }
          },
          children: /*#__PURE__*/_jsx(Accordion, {
            children: rootGroups.map(function (group, index) {
              return /*#__PURE__*/_jsx(Item, {
                header: group.title,
                children: group.categories.map(function (category) {
                  return /*#__PURE__*/_jsx(CategoryLink, {
                    onClick: function onClick(e) {
                      if (onCategoryOpen) {
                        e.preventDefault();
                        onCategoryOpen(category);
                      }
                    },
                    href: category.href,
                    children: category.title
                  }, category.title);
                })
              }, index);
            })
          })
        })
      });
    }
  });
});
CategoryNavMobile.displayName = 'CategoryNavMobile';
var CategoryLink = styled(Link).attrs({
  $size: 'default',
  $styles: {
    marginLeft: [20, null, null, null],
    paddingBottom: [30, null, null, null]
  }
}).withConfig({
  displayName: "Mobile__CategoryLink",
  componentId: "sc-icefsd-0"
})(["display:block;text-align:left;font-weight:400;color:", ";border-bottom:none;"], function (props) {
  return props.theme.templates.colors.secondary60;
});
export default CategoryNavMobile;